import {DefaultInteraction} from "./interaction";

export class ObjectAnimation extends DefaultInteraction {

	scene
	handler = null //Animation handler

	constructor(props) {
		super(props);
		this.scene = props.scene
		this.handler = props.handler
	}

	key() {
		return "animate_object"
	}

	/**
	 * Called onClick or when starting a proximity event
	 *
	 * @param interactionData
	 * @param metadata
	 * @param onSuccess
	 * @param onError
	 */
	interact(interactionData, metadata, onSuccess, onError) {
		console.log(`Interaction::${this.key()} - Run`, interactionData, metadata, this.handler)

		const refObj = this.scene.get(interactionData.target_id) //TODO is target_id correct or should we use base item as target? - Proximity wise

		console.log("Object animate", refObj)
		this._startAnimation(refObj.uuid, interactionData.animation_name)

		return !interactionData.blocking //If we are blocking return false so we dont call onSuccess
	}

	/**
	 * TODO Start rotation object on enter (if proximity)
	 * @param interaction
	 * @param interactable
	 */
	onProximityEnter(interaction, interactable) {
		console.log("Proximity enter", interactable.userData.alphaID, interactable)
		this.runInteraction(interaction.data, {
				skipToggle: true,
			}, () => {}, () => {})
	}

	/**
	 * TODO remove rotation object on exit
	 * @param interactable
	 */
	onProximityExit(interactable) {
		console.log("Proximity exit", interactable.userData.alphaID, interactable)
		this._stopAnimation(interactable.userData.alphaID, "")
	}

	_stopAnimation(alphaID, animationName) {
		this.handler.stop(alphaID, animationName)
	}

	_startAnimation(alphaID, animationName) {
		this.handler.play(alphaID, animationName)
	}
}